/* wsapi3-prod-list v1.0 */
/* Deploy Version 2026-10-12 09:43:35 */
/* Deploy Version 2026-09-24 19:11:13 */
/* Deploy Version 2026-07-27 16:11:02 */
wsMain.createModule({
  // Module name
  name: 'product-list',
  version: '1.0',
  updatedAt: '2026-07-14',
  // Module function name
  function: 'get',
  actualGroup: 0,
  groupLength: document.querySelectorAll(`[data-wsjs-prod-list='group']`)?.length || false,
  // Configuration 
  options: {
    templateConfigs: {
      "image": true,
      "name": true,
      "price-main": true,
      "price-second": true,
      "price-installment": true,
      "price-cash": true,
      "button": false,
      "quantity-selector": false,
      "desconto": true,
      "lancamento": true,
      "frete-gratis": true,
      "favorito": true,
      "lazyLoad": true,
      "imageSize": 'MED',
      "startingOff": true,
      "redirect": false
    },
  },
  data: {},
  // Module Trigger
  async get() {
    wsMain.modules['product-list'].actualGroup = 0;
    wsMain.modules['product-list'].data['group'] = {};

    let isLancamento = Boolean(document.querySelector(`[data-wsjs-prod-list='lancamento']`));

    // Se todas as âncoras "group" já vieram prontas do servidor, não precisa buscar nem
    // aparar excedente aqui (o SSR já fez isso) — pula direto pro loop de baixo, que detecta
    // isso por âncora e só monta o slider em cima do que já existe. Esperar essa busca antes
    // de montar o slider é o que tornava a transformação pra carrossel visível (o usuário via
    // o grid estático virar slider um instante depois, já com a página pintada). Não pula se
    // existir âncora "lancamento" — ela depende dos mesmos dados buscados aqui e o servidor
    // ainda não sabe renderizar esse tipo.
    let groupAnchorsUpfront = document.querySelectorAll(`[data-wsjs-prod-list='group']`);
    let groupAlreadyRendered = !isLancamento && groupAnchorsUpfront.length > 0 &&
      Array.from(groupAnchorsUpfront).every(a => a.hasAttribute('data-ws-rendered'));

    if (!groupAlreadyRendered && (wsMain.modules['product-list'].groupLength > 0 || isLancamento)) {
      wsMain.modules['product-list'].data['group'] = await ApiWS.Calls.listProducts['group']({
        prodLancamento: isLancamento ? '1' : null
      });
    }

    if (isLancamento) {
      let lancamentoIdx = false;
      wsMain.modules['product-list'].data['group'].grupos.forEach((group, groupIdx) => {
        if (group.type == 'lancamento') lancamentoIdx = groupIdx;
      });
      if (lancamentoIdx != false) wsMain.modules['product-list'].data['lancamento'] = wsMain.modules['product-list'].data['group'].grupos.splice(lancamentoIdx, 1);
    }

    if (!groupAlreadyRendered && wsMain.modules['product-list'].groupLength > 0) {
      let groups = document.querySelectorAll(`[data-wsjs-prod-list='group']`);
      if (!wsMain.modules['product-list'].data['group'].grupos) wsMain.modules['product-list'].data['group'].grupo  = [];
      while (wsMain.modules['product-list'].data['group'].grupos.length < groups.length && document.querySelector(`[data-wsjs-prod-list='group']`)) {
        groups[groups.length - 1].remove();
        groups = document.querySelectorAll(`[data-wsjs-prod-list='group']`);
        wsMain.modules['product-list'].groupLength = groups.length;
      }
    }

    let promises = Array.from(document.querySelectorAll('[data-wsjs-prod-list]')).map(async elm => {
      let functionName = elm.getAttribute('data-wsjs-prod-list');
      if (functionName == 'template-empty-search' || functionName == 'template-empty-category') return;

      // Se TODAS as âncoras desse tipo já vieram prontas do servidor (data-ws-rendered), não
      // busca nem reconstrói os cards — evita o fetch redundante e o "pulo" de layout de
      // descartar/recriar o que já está certo. O servidor já deixa o .prod-list-holder no
      // "frame inicial" do slider via CSS (data-ws-slide-preview: só os slides.perView
      // primeiros produtos visíveis, resto clipado por overflow:hidden) — então rodar
      // createSlide() aqui só adiciona a navegação (arraste/setas) em cima do que já está
      // pintado, sem mudar o que já está visível. Só confia nisso quando é unânime: com
      // múltiplas âncoras "group", se alguma não veio do SSR, mantém o fluxo original
      // completo pra não bagunçar a distribuição round-robin entre elas.
      let sameTypeAnchors = document.querySelectorAll(`[data-wsjs-prod-list="${functionName}"]`);
      if (sameTypeAnchors.length && Array.from(sameTypeAnchors).every(a => a.hasAttribute('data-ws-rendered'))) {
        let ssrSlideOptions = wsMain.tools.getWsData(elm, 'slide');
        if (ssrSlideOptions) {
          elm.querySelectorAll('.prod-list-holder').forEach(holder => {
            // createSlide() pega TODOS os filhos do holder, inclusive os produtos que o
            // servidor escondeu com display:none pro "frame inicial" — o KeenSlider tenta
            // medir esses itens invisíveis (largura 0) e a conta de tamanho "explode".
            // Remove o display:none antes: o KeenSlider passa a controlar quem fica
            // visível de verdade.
            Array.from(holder.children).forEach(child => { if (child.style.display === 'none') child.style.display = ''; });
            // Força reflow síncrono — sem isso o KeenSlider mede o container antes do
            // reflow do display:none acima ter sido processado.
            void holder.offsetHeight;
            let [slideSuccess, slider] = wsMain.tools.createSlide(holder, ssrSlideOptions);
            if (slideSuccess && slider) {
              slider.update();
              // Segunda rede de segurança (mesmo padrão do wsapi3-banners.js): reconfere
              // o tamanho depois que o browser realmente pintou o frame.
              setTimeout(() => slider.update(), 50);
            }
          });
        }
        // Seções da home (data-wsjs-container) começam com display:none!important
        // (anti-FOUC do editor drag-and-drop) e só ficam visíveis quando dataLoad()
        // sobe a árvore removendo esse atributo dos ancestrais — isso normalmente
        // acontece dentro de replaceSpanTag(), que a gente pulou de propósito aqui.
        wsMain.addons.dataLoad(elm);
        return;
      }

      let options = wsMain.tools.getWsData(elm, 'options');
      let slideOptions = wsMain.tools.getWsData(elm, 'slide');
      let prodsPerlineSet = functionName == 'category' ? '{prodperline-categorie-var}' : '{prodperline-var}';
      let prodsPerLineVar = !isNaN(parseInt(prodsPerlineSet)) ? prodsPerlineSet : 4;

      if (slideOptions.slides && slideOptions.slides.perView) prodsPerLineVar = slideOptions.slides.perView;
      if (options['prods-perline']) prodsPerLineVar = options['prods-perline'];

      if (document.querySelector('#HD_VRS_MOBILE').value.toLowerCase() == 'true' && prodsPerLineVar >= 3) prodsPerLineVar = 2;

      let data = wsMain.modules['product-list'].data[functionName] || await ApiWS.Calls.listProducts[functionName](prodsPerLineVar);
      // Se o SSR já preencheu a âncora (seção inteira renderizada OU só o preview de um
      // carrossel), elm.innerHTML não é mais o texto puro do título — usar o título original
      // preservado em data-ws-original-title nesses casos (presente sempre que o servidor
      // mexeu no conteúdo da âncora, com ou sem data-ws-rendered nela), senão a reconstrução do
      // client injetaria HTML inteiro dentro do <h2>.
      let text = elm.hasAttribute('data-ws-original-title') ? elm.getAttribute('data-ws-original-title') : elm.innerHTML;
      let breve = '';

      try {
        breve = elm.parentNode.parentNode.querySelector('template').innerHTML;
      } catch (err) { }

      let vrfSearch = document.querySelector('#LV_HD_BUSCA_VALOR');
      if (vrfSearch || document.querySelector("body").classList.contains('PagFabricante')) document.querySelectorAll('*[data-wsjs-search="false"]').forEach(item => item.remove());

      if (data && (data?.totalitens > 0 || data?.grupos?.length > 0 || data.length > 0)) {
        if (typeof nPanel != 'undefined' && nPanel.token && data["wssource"] == "ws-plchold") {
          if (functionName == 'group' || functionName == 'previous') {
            for (let i = data.grupos.length; i < wsMain.modules['product-list'].groupLength; i++) {
              data.grupos = [...data.grupos, data.grupos[0]];
            }
          }

          if (functionName == 'home') {
            let prodsPerline = 4;
            prodsPerline = !isNaN(parseInt('{prodperline-var}')) ? parseInt('{prodperline-var}') : prodsPerline;
            data.produtos = data.produtos.slice(0, (prodsPerline * 2));
          }

        }

        wsMain.modules['product-list'].create[functionName](data, options, text, breve);
        try {
          document.querySelectorAll('*[data-wsjs-remove]').forEach(elm => elm.removeAttribute('data-wsjs-remove'));
        } catch (_) { }

      } else if (functionName == 'category') wsMain.modules['product-list'].showEmpty();
    });

    await Promise.all(promises);
    wsMain.modules['product-list'].appPromoRelampago();
    return true;
  },
  create: {
    group(returnJson) {
      this.list(returnJson?.grupos, 'group');
    },
    related(returnJson, options, text, breve) {
      this.list([{ codigo: 'relacionados', nome: text, breve: breve, produtos: returnJson }], 'related');
    },
    suggestion(returnJson, options, text, breve) {
      this.list([{ codigo: 'sugestoes', nome: text, breve: breve, produtos: returnJson }], 'suggestion');
    },
    // Vitrines de indicação (ApiWS.Calls.listProducts._recommendation) — o nome da âncora é
    // o source do /product/list.
    'related-store'(returnJson, options, text, breve) {
      this.list([{ codigo: 'related-store', nome: text, breve: breve, produtos: returnJson }], 'related-store');
    },
    'related-similar'(returnJson, options, text, breve) {
      this.list([{ codigo: 'related-similar', nome: text, breve: breve, produtos: returnJson }], 'related-similar');
    },
    'related-category'(returnJson, options, text, breve) {
      this.list([{ codigo: 'related-category', nome: text, breve: breve, produtos: returnJson }], 'related-category');
    },
    'bought-together'(returnJson, options, text, breve) {
      this.list([{ codigo: 'bought-together', nome: text, breve: breve, produtos: returnJson }], 'bought-together');
    },
    'navigation'(returnJson, options, text, breve) {
      this.list([{ codigo: 'navigation', nome: text, breve: breve, produtos: returnJson }], 'navigation');
    },
    'new-releases'(returnJson, options, text, breve) {
      this.list([{ codigo: 'new-releases', nome: text, breve: breve, produtos: returnJson }], 'new-releases');
    },
    previous(returnJson, options, text, breve) {
      this.list([{ codigo: 'ultimo', nome: text, breve: breve, produtos: returnJson?.produtos || returnJson }], 'previous');
    },
    home(returnJson, options, text, breve) {
      this.list([{ codigo: 'home', nome: text, breve: breve, produtos: returnJson.produtos }], 'home');
    },
    lancamento(returnJson, options, text, breve) {
      this.list([{ codigo: 'lancamento', nome: returnJson[0].nome, breve: "", produtos: returnJson[0].produtos }], 'lancamento');
    },
    async category(returnJson, options, text, breve, infinity = false) {

      if (infinity) {
        let templateConfigs = JSON.parse(JSON.stringify(wsMain.options['product-list'].templateConfigs));
        let optionsUsed = wsMain.tools.getWsData(document.querySelector(`[data-wsjs-prod-list="category"]`), 'options') || {};

        templateConfigs = { ...templateConfigs, ...optionsUsed };
        if (!templateConfigs.imgArea) templateConfigs.imgArea = 'produtos-category';

        let template = document.querySelector('[data-wsjs-module="prod-template"] > *');
        let variations = wsMain.modules['product-list'].variations;
        let varCfg = variations.config(wsMain.modules['product-list'].anchorOptions?.category || optionsUsed);

        let arrProds = [];

        for (let z = 0; z < returnJson.produtos.length; z++) {
          let actualProd = returnJson.produtos[z];
          try {
            let card = wsMain.modules['prod-template'].createProd(actualProd, template.cloneNode(true), templateConfigs);
            variations.apply(card, actualProd, varCfg);
            arrProds.push(card);
          } catch (e) {
            console.log('Erro com o produto');
            console.log(returnJson.produtos[z]);
            console.error(e);
          }
        }
        return arrProds;

      } else {
        this.list([{ codigo: 'category', nome: text, breve: '', produtos: returnJson.produtos }], 'category');
      }
    },
    list(arr, name) {
      try {
        function formatSequence(a, b) {
          const initialArr = [];
          for (let i = 0; i < a; i++) initialArr.push(i);

          const output = [];
          let lastIndex = 0;
          const chunkSize = a === b ? 1 : parseInt(a / b);

          for (let i = 0; i < b; i++) {
            const value = initialArr.slice(lastIndex, i == b - 1 && a / b % 1 ? lastIndex + chunkSize + 1 : lastIndex + chunkSize);
            output.push(value);
            lastIndex += chunkSize;
          }

          return output;
        }

        let templateConfigs = JSON.parse(JSON.stringify(wsMain.options['product-list'].templateConfigs));
        let anchorSlideOptions = wsMain.tools.getWsData(document.querySelector(`[data-wsjs-prod-list="${name}"]`), 'slide') || false;
        let optionsUsed = wsMain.tools.getWsData(document.querySelector(`[data-wsjs-prod-list="${name}"]`), 'options') || {};

        templateConfigs = { ...templateConfigs, ...optionsUsed };
        // Área do Cloudflare Image Resizing (imageResize do head) — mesmo default do SSR (product-list-server-render.service.ts).
        if (!templateConfigs.imgArea) templateConfigs.imgArea = 'produtos-' + name;
        templateConfigs.listName = name;

        // Guarda as opções da âncora: ela é substituída logo abaixo e o scroll infinito
        // (create.category com infinity) precisa da mesma config de variações.
        let variations = wsMain.modules['product-list'].variations;
        wsMain.modules['product-list'].anchorOptions = wsMain.modules['product-list'].anchorOptions || {};
        wsMain.modules['product-list'].anchorOptions[name] = optionsUsed;
        let varCfg = variations.config(optionsUsed);

        // Os relacionados novos herdam o visual do "related" atual (.prod-list-related do
        // wsapi3-pag-prod-rules / wirestyle-mobile) só quando a âncora está dentro do bloco do
        // produto — numa seção própria abaixo dele seguem o visual de carrossel comum.
        let relatedClass = ['related-store', 'related-similar', 'related-category', 'bought-together'].includes(name) &&
          document.querySelector(`[data-wsjs-prod-list="${name}"]`)?.closest('[data-wsjs-product="container"]') ? 'prod-list-related' : '';

        let template = document.querySelector('[data-wsjs-module="prod-template"] > *');

        if (!Array.isArray(arr) && arr.length == 0) return;

        let groupSection = wsMain.tools.createElm('div');

        // Anexa a seção vazia ANTES do loop preencher com os grupos (era só no fim/por
        // iteração) — createSlide(), chamado abaixo pra cada grupo, mede a largura do container
        // pra calcular o tamanho de cada produto, e um elemento fora do documento sempre mede 0.
        // Isso fazia o carrossel alternar entre altura 0 e a altura real logo depois de montado,
        // empurrando tudo abaixo dele na página (inclusive seções bem mais acima na tela, já que
        // o navegador agrupa isso num único evento de troca de layout). Como groupSection é
        // reaproveitado a cada iteração (só tem conteúdo append()ado nele), inserir vazio aqui e
        // popular depois não muda nada visualmente — só tira a medição errada do meio do caminho.
        wsMain.tools.replaceSpanTag(groupSection, `prod-list="${name}"`, false, false);

        let arrSlider = [];

        arr.forEach((actualGroup, i) => {
          if (!Array.isArray(actualGroup.produtos) || actualGroup.produtos.length == 0) return;

          let groupHolder = wsMain.tools.createElm({
            type: 'section',
            attrs: {
              class: `prod-list prod-list-${name} ${relatedClass} ${templateConfigs.container != false ? 'container' : ''}`,
              id: 'code-list-' + actualGroup.codigo
            }
          });

          let divTexts = wsMain.tools.createElm({
            type: 'div',
            attrs: {
              class: 'prod-list-titles'
            }
          });

          let titleHiperLink = wsMain.tools.createElm({
            type: 'a',
            attrs: {
              class: 'prod-list-hiperlink',
              href: actualGroup.url && actualGroup.url != '' ? actualGroup.url : '#code-list-' + actualGroup.codigo
            }
          });

          function getTempInner(str) {
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = str;
            let strToReturn = tempDiv.innerHTML;
            tempDiv.remove();
            return strToReturn
          }

          let groupTitle = wsMain.tools.createElm({
            type: 'h2',
            innerHTML: actualGroup.nome || '',
            attrs: {
              class: 'prod-list-titles-title'
            }
          });

          if (name != 'group') {
            if (!actualGroup.breve || actualGroup.breve.trim() == '') {
              let dragBreve = document.querySelector(`template[data-wsjs-prod-list-template="${name}"]`)?.innerHTML.trim() || '';

              if (dragBreve.trim() != '') actualGroup.breve = dragBreve;

            }
          }

          let subtitle = wsMain.tools.createElm({
            type: 'p',
            innerHTML: actualGroup.breve || '',
            attrs: {
              class: 'prod-list-titles-subtitle'
            }
          });

          if (typeof nPanel != 'undefined' && nPanel.token) {
            groupTitle.setAttribute("data-wsjs-dragHolder", getTempInner("Digite aqui um t&iacute;tulo para sua listagem de produtos"));
            subtitle.setAttribute("data-wsjs-dragHolder", getTempInner("Digite aqui um par&aacute;grafo para chamar a aten&ccedil;&atilde;o de seus clientes"));
          }

          titleHiperLink.append(groupTitle);

          let groupList = wsMain.tools.createElm({
            type: 'div',
            attrs: {
              class: 'prod-list-holder'
            }
          });

          if (name != 'group' && (typeof nPanel != 'undefined' && nPanel.token)) {
            subtitle.setAttribute('contenteditable', 'plaintext-only')
            groupTitle.setAttribute('contenteditable', 'plaintext-only')
          }

          if (actualGroup.nome || (typeof nPanel != 'undefined' && nPanel.token)) divTexts.append(titleHiperLink);
          if (actualGroup.breve || (typeof nPanel != 'undefined' && nPanel.token)) divTexts.append(subtitle);

          // A âncora original já foi substituída (groupSection é inserido antes do loop, ver
          // comentário acima) — usa o slide config capturado dela no topo da função, em vez de
          // tentar re-consultar um elemento que não existe mais no documento.
          let slideOptions = anchorSlideOptions;
          if (name == 'group' && !slideOptions && wsMain.modules['product-list'].cache) slideOptions = wsMain.modules['product-list'].cache;
          if (slideOptions && name == 'group') wsMain.modules['product-list'].cache = slideOptions;
          let slideSuccess;

          let prodsPerlineSet = name == 'category' ? '{prodperline-categorie-var}' : '{prodperline-var}';
          let prodsPerLineVar = !isNaN(parseInt(prodsPerlineSet)) ? prodsPerlineSet : 4;

          if (document.querySelector('#HD_VRS_MOBILE').value.toLowerCase() == 'true' && prodsPerLineVar >= 3) prodsPerLineVar = 2;

          if (!slideOptions && (!slideOptions.slides || !slideOptions.slides.perView)) {
            if (!isNaN(parseInt(prodsPerLineVar)) && parseInt(prodsPerLineVar) > 3 && !templateConfigs.imageSize) templateConfigs.imageSize = 'PEQ';
            if (!isNaN(parseInt(prodsPerLineVar)) && parseInt(prodsPerLineVar) <= 3 && !templateConfigs.imageSize) templateConfigs.imageSize = 'MED';
          }

          if (slideOptions && (!slideOptions.slides || !slideOptions.slides.perView)) {
            try {
              if (!isNaN(parseInt(prodsPerLineVar))) {
                if (!slideOptions.slides) slideOptions.slides = {}
                slideOptions.slides['perView'] = prodsPerLineVar
              }
            } catch (err) {
              console.log(err)
            }
          } else {
            try {
              // alert(optionsUsed['prods-perline'])
              prodsPerLineVar = optionsUsed['prods-perline'] ? optionsUsed['prods-perline'] : prodsPerLineVar;
              wsMain.globalData.infoLoja.perLineProds = prodsPerLineVar
            } catch (err) {
              console.log(err)
            }
          }

          try {
            if (slideOptions.slides.perView > 3 && !templateConfigs.imageSize) {
              templateConfigs.imageSize = 'PEQ';
            }
            if (slideOptions.slides.perView <= 3 && !templateConfigs.imageSize) {
              templateConfigs.imageSize = 'MED';
            }
          } catch (err) { }

          for (let z = 0; z < actualGroup.produtos.length; z++) {
            let actualProd = actualGroup.produtos[z];
            try {
              let card = wsMain.modules['prod-template'].createProd(actualProd, template.cloneNode(true), templateConfigs);
              variations.apply(card, actualProd, varCfg);
              groupList.append(card);
            } catch (e) {
              console.log('Erro com o produto', actualGroup.produtos[z])
              console.error(e);
            }
          }

          let hasTitle = actualGroup.breve || actualGroup.nome || (typeof nPanel != 'undefined' && nPanel.token);

          // Carrossel (slideOptions truthy): .prod-list-titles precisa ser IRMÃ do groupList (que
          // createSlide() abaixo transforma em .keen-slider), não filha dele — o CSS posiciona o
          // título via grid-row/grid-column no grid do PRÓPRIO groupHolder (.prod-list/
          // .prod-list-related), não no de groupList. Appendar dentro de groupList (como o ramo
          // sem slide faz, de propósito — ver gridColumnEnd mais abaixo) deixava o título fora de
          // qualquer grid, sobrando no fim do slider (depois dos produtos) em vez de no topo.
          if (hasTitle && slideOptions) groupHolder.append(divTexts);
          groupHolder.append(groupList);
          if (hasTitle && !slideOptions) groupList.append(divTexts);

          if (name != 'group') {
            let groupClone = wsMain.tools.createElm('div');
            groupClone.append(groupHolder);

            groupSection.append(groupClone);
            let attributes = wsMain.tools.getWsData(document.querySelector(`[data-wsjs-prod-list="${name}]"`), 'options');

            // groupSection já foi inserido no documento antes do loop (ver comentário acima) —
            // não repete o replaceSpanTag aqui: nesse ponto o placeholder original já não existe
            // mais, e chamar de novo achava (e "roubava" via moveção de nó) a PRÓXIMA âncora
            // ainda livre em vez de não fazer nada.

            if (name == 'category') {
              try {
                if (templateConfigs.infinity || wsAppsConfig?.infinityList) {
                  groupSection.setAttribute('data-wsjs-options', attributes);
                  groupList.setAttribute('data-wsjs-infinity', 'holder');

                  document.querySelector('[data-wsjs-pagination="container"]').innerHTML =
                    '<button class="button-second" data-wsjs-infinityButton>Carregar mais produtos</button>'

                  document.querySelector('[data-wsjs-pagination="container"] [data-wsjs-infinityButton]').addEventListener('click', wsMain.modules['category-filter'].infinityList);

                  if (templateConfigs.infinity == 'scroll' || wsAppsConfig?.infinityList == '2') {
                    document.addEventListener("scroll", wsMain.modules['category-filter'].infinityScroll);
                  }
                  wsMain.modules['category-filter'].syncInfinity(wsMain.globalData.listCategoryProds);
                }


              } catch (err) {
                console.log(err)
              }
            }
          }

          if (name == 'group') {
            // groupSection já está no documento (inserido antes do loop) — só falta anexar os
            // grupos que cabem nessa âncora; não repete o replaceSpanTag aqui pelo mesmo motivo
            // do ramo acima.
            if (wsMain.modules['product-list'].groupLength == 1) {
              groupSection.append(groupHolder);
            } else {
              let actualSequence = formatSequence(arr.length, wsMain.modules['product-list'].groupLength)[wsMain.modules['product-list'].actualGroup];
              if (actualSequence.indexOf(i) != -1) {
                groupSection.append(groupHolder);
              }
            }
          }

          // Monta o slide só depois de groupList estar de fato no documento (via groupHolder ->
          // groupSection, já anexado antes do loop) — createSlide()/KeenSlider mede a largura
          // real do container em vez de 0, evitando o vaivém de altura (e o CLS que ele causa
          // nas seções abaixo) que rolava quando isso era medido num elemento ainda desanexado.
          if (slideOptions) {
            [slideSuccess, arrSlider[i]] = wsMain.tools.createSlide(groupList, slideOptions);
            wsMain['prod-slides'].push(arrSlider[i]);
            if (!slideSuccess) return;
          } else {
            groupList.style['gridTemplateColumns'] = `repeat(${prodsPerLineVar}, 1fr)`;
            divTexts.style['gridColumnEnd'] = `${parseInt(parseInt(prodsPerLineVar) + 1)}`;
          }

          if (slideOptions) arrSlider[i].update();
        });

        // wsMain.modules['product-list'].actualGroup++;
        if (name == 'group') wsMain.modules['product-list'].actualGroup++;

        let existArrow = false;
        document.querySelectorAll('.prod-list').forEach(elm => {
          if (elm.querySelector('.arrow--prev')) existArrow = true;
        });

        if (existArrow) {
          document.querySelectorAll('.prod-list .need-offset').forEach(elm => {
            elm.classList.add('prod-list-offset');
            elm.classList.remove('need-offset');
          });
        }

        wsMain['prod-slides'].forEach(slider => slider.update());
      } catch (err) {
        console.log(err);
      }
    },
  },
  // Variações no card (show_variation / variation_with_photo / max_vars no data-wsjs-options
  // da âncora, ou no objeto global productListVariations do head — a âncora vence, chave a
  // chave). Espelho exato de src/layout/product-list-variations.ts (SSR): mesma regra e mesma
  // marcação, manter os dois iguais.
  variations: {
    // true → todos os tipos; "attr_1209,attr_1210" (ou array) → só esses type_id; resto → desligado.
    parseFilter(value) {
      if (value === true || value === 'true') return 'all';
      if (value === undefined || value === null || value === false) return null;
      let list = Array.isArray(value) ? value : String(value).split(',');
      let ids = list.map(item => String(item).trim().replace(/^attr_/i, '')).filter(item => /^\d+$/.test(item));
      return ids.length ? ids : null;
    },
    config(options) {
      let globalCfg = null;
      // let global não fica em window — mesmo jeito de ler do variationMode.
      try { if (typeof productListVariations == 'object' && productListVariations) globalCfg = productListVariations; } catch (err) { }

      let pick = key => (options && options[key] !== undefined ? options[key] : (globalCfg ? globalCfg[key] : undefined));
      let rawShow = pick('show_variation');
      if (rawShow === false || rawShow === 'false') return null;
      let photo = this.parseFilter(pick('variation_with_photo'));
      // variation_with_photo sozinho já liga a exibição (dos tipos que ele cobre).
      let show = this.parseFilter(rawShow) || photo;
      if (!show) return null;
      let max = parseInt(pick('max_vars'));
      return { show, photo, max: max >= 1 ? max : 1 };
    },
    // Nome de tipo/valor em forma de seletor ("Tamanho" → tamanho, "Azul Claro" → azul-claro).
    slug(value) {
      return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
    },
    inFilter(filter, typeId) {
      return filter === 'all' || (Array.isArray(filter) && filter.includes(typeId));
    },
    groups(prod, cfg) {
      let groups = [];
      (Array.isArray(prod.variacoes) ? prod.variacoes : []).forEach(variation => {
        (variation.atributos || []).forEach(attr => {
          let value = String(attr.valor ?? '').trim();
          let typeId = String(attr.tipo_id ?? attr.tipo ?? '').trim();
          if (!value || !typeId) return;
          let group = groups.find(g => g.typeId === typeId);
          if (!group) {
            group = { typeId, typeName: attr.tipo || '', photo: this.inFilter(cfg.photo, typeId), items: [] };
            groups.push(group);
          }
          let item = group.items.find(i => i.value === value);
          if (!item) {
            // Atributo de cor vem como "Nome|#hex" (o # é opcional): vira quadradinho colorido.
            let color = /^(.*)\|\s*#?([0-9a-f]{6}|[0-9a-f]{3})\s*$/i.exec(value);
            item = { id: '', value, label: color ? color[1].trim() : value, color: color ? '#' + color[2] : '', image: '', available: false };
            group.items.push(item);
          }
          // Id da variação que o clique manda pro carrinho: a 1ª disponível com esse valor.
          if (!item.id || (!item.available && variation.disponivel !== false)) item.id = String(variation.id ?? '');
          if (variation.disponivel !== false) item.available = true;
          if (!item.image) item.image = variation.imagem_pequena || variation.imagem || '';
        });
      });

      // Tipo com foto em que só parte das variações tem foto: as demais usam a foto principal do
      // produto. Nenhuma com foto → seguem em cor/texto.
      let mainPhoto = Array.isArray(prod.fotos) && typeof prod.fotos[0] == 'string' ? prod.fotos[0] : '';
      if (mainPhoto && !/.(mp4|webm)$/i.test(mainPhoto)) {
        groups.forEach(group => {
          if (!group.photo || !group.items.some(item => item.image)) return;
          group.items.forEach(item => { if (!item.image) item.image = mainPhoto; });
        });
      }

      // max_vars conta os tipos que o PRODUTO tem, não os que passam no filtro.
      if (!groups.length || groups.length > cfg.max) return { groups: [], singleType: false };
      // Com mais de um tipo, um valor sozinho não identifica a variação — o clique só leva ao produto.
      return { groups: groups.filter(g => this.inFilter(cfg.show, g.typeId)), singleType: groups.length === 1 };
    },
    // Monta o bloco sobre a base da foto do card (aparece no hover — wsapi3-prod-list.css).
    apply(card, prod, cfg) {
      try {
        if (!cfg || !card || !prod) return;
        let holder = card.querySelector('.prod-showcase-image');
        if (!holder || holder.querySelector('.prod-showcase-variations')) return;
        let { groups, singleType } = this.groups(prod, cfg);
        if (!groups.length) return;

        // Setas da rolagem horizontal: nascem ocultas, updateArrows() mostra quando estoura.
        let arrow = dir => {
          let button = document.createElement('button');
          button.type = 'button';
          button.className = 'prod-showcase-variations-arrow ' + dir;
          button.setAttribute('aria-label', dir == 'prev' ? 'Anteriores' : 'Próximas');
          button.hidden = true;
          button.textContent = dir == 'prev' ? '\u2039' : '\u203A';
          return button;
        };

        let url = prod.links?.ver_produto || 'javascript:;';
        let container = document.createElement('div');
        container.className = 'prod-showcase-variations';
        container.setAttribute('data-ws-var-types', groups.length);

        groups.forEach(group => {
          let ul = document.createElement('ul');
          ul.className = 'prod-showcase-variations-list';
          // Seletores pro tema: tipo por id e por nome, valor por nome — em atributo e em classe.
          let typeSlug = this.slug(group.typeName) || this.slug(group.typeId);
          let typeAttrs = elm => {
            elm.setAttribute('data-ws-var-type', group.typeId);
            elm.setAttribute('data-ws-var-type-name', typeSlug);
          };
          typeAttrs(ul);
          ul.setAttribute('aria-label', group.typeName);

          group.items.forEach(item => {
            let withPhoto = group.photo && item.image;
            let li = document.createElement('li');
            let valueSlug = this.slug(item.label);
            li.className = 'prod-showcase-variation prod-showcase-variation-' + typeSlug +
              (valueSlug ? ' prod-showcase-variation-' + typeSlug + '-' + valueSlug : '') +
              (withPhoto ? ' has-photo' : (item.color ? ' has-color' : ' has-text')) + (!item.available ? ' unavailable' : '');
            typeAttrs(li);
            li.setAttribute('data-ws-var-value', valueSlug);
            let a = document.createElement('a');
            a.setAttribute('href', url);
            a.setAttribute('title', item.label);
            a.setAttribute('aria-label', item.label);
            // Com botão "Adicionar" no card, o clique põe ESSA variação no carrinho (ver o listener no fim do arquivo).
            if (singleType && item.available && /^\d+$/.test(item.id)) a.setAttribute('data-ws-var-id', item.id);

            if (withPhoto) {
              let img = document.createElement('img');
              // Sem src: a foto só é baixada no primeiro hover do card (loadPhotos).
              img.setAttribute('data-ws-var-src', item.image);
              img.setAttribute('alt', item.label);
              img.setAttribute('width', '50');
              img.setAttribute('height', '50');
              a.append(img);
            } else if (item.color) a.style.backgroundColor = item.color;
            else a.textContent = item.label;

            li.append(a);
            ul.append(li);
          });

          let row = document.createElement('div');
          row.className = 'prod-showcase-variations-row prod-showcase-variations-row-' + typeSlug;
          typeAttrs(row);
          row.append(arrow('prev'), ul, arrow('next'));
          container.append(row);
        });

        holder.append(container);
        card.classList.add('has-variations');
      } catch (err) {
        console.log(err);
      }
    },
    // As fotos das variações nascem sem src (data-ws-var-src) e só são baixadas aqui, no
    // primeiro hover/toque/foco do card — a faixa fica oculta até lá.
    loadPhotos(scope) {
      (scope || document).querySelectorAll('.prod-showcase-variations img[data-ws-var-src]').forEach(img => {
        img.setAttribute('src', img.getAttribute('data-ws-var-src'));
        img.removeAttribute('data-ws-var-src');
      });
    },
    // Mostra a seta de cada lado só enquanto houver o que rolar pra lá.
    updateArrows(scope) {
      (scope || document).querySelectorAll('.prod-showcase-variations-row').forEach(row => {
        let ul = row.querySelector('.prod-showcase-variations-list');
        let prev = row.querySelector('.prod-showcase-variations-arrow.prev');
        let next = row.querySelector('.prod-showcase-variations-arrow.next');
        if (!ul || !prev || !next) return;
        let max = ul.scrollWidth - ul.clientWidth;
        prev.hidden = ul.scrollLeft <= 1;
        next.hidden = max <= 1 || ul.scrollLeft >= max - 1;
      });
    }
  },
  showEmpty() {
    let vrfSearch = document.querySelector('#LV_HD_BUSCA_VALOR');

    let container = wsMain.tools.createElm({
      type: 'div',
      attrs: {
        class: 'prod-list-empty'
      }
    });

    if (vrfSearch) container.innerHTML = document.querySelector('[data-wsjs-prod-list="template-empty-search"]').innerHTML.replace('{{value}}', vrfSearch.value);
    else container.innerHTML = document.querySelector('[data-wsjs-prod-list="template-empty-category"]').innerHTML;

    wsMain.tools.replaceSpanTag(container, document.querySelector('[data-wsjs-prod-list="category"]'));
  },
  appPromoRelampago() {
    if(typeof ws_promrelampago !== 'boolean') return
    if(!ws_promrelampago) return

    function calculateTimeRemaining(dateString) {
      const targetDate = new Date(dateString);
      const now = new Date();
      
      const differenceMs = targetDate - now;
    
      if (differenceMs <= 0) {
        return "";
      }
    
      const oneMinute = 60 * 1000;
      const oneHour = 60 * oneMinute;
      const oneDay = 24 * oneHour;
    
      if (differenceMs < oneMinute) {
        return ""; 
      } else if (differenceMs < oneHour) {
        const minutes = Math.floor(differenceMs / oneMinute);
        return `${minutes} minutes`;
      } else if (differenceMs < 48 * oneHour) {
        const hours = Math.floor(differenceMs / oneHour);
        return `${hours} horas`;
      } else {
        const days = Math.floor(differenceMs / oneDay);
        return `${days} dias`;
      }
    }
    
    function createPromoRelampagoElement(selector, data) {
      if(!selector || !data) return

      const prods = document.querySelectorAll(selector)

      prods.forEach(prod => {
        const div = document.createElement('div')
        div.classList.add('ws-promo-relampago-container')
        const timeRemaining = calculateTimeRemaining(data)
        div.innerHTML = `
        <p class="ws-promo-relampago__content prod-tags">Promo&ccedil;&atilde;o v&aacute;lida por ${timeRemaining}</p>
        `
  
        prod.appendChild(div)
      })
    }

    try {
      const etapa = document.querySelector("#HdEtapaLoja").value

      function appendPromoRelampagoElm(prodsArr) {
        if(!prodsArr || !prodsArr.length) return

        const products = [];
        const seenProd = new Set();

        prodsArr.forEach(obj => {
          if (!seenProd.has(obj.codigo)) {
            seenProd.add(obj.codigo);
            products.push(obj);
          }
        });

        if(!products) return

        products.forEach(prod => {
          const date =  prod?.precos?.preco_promocao_validade

          if(!date) return

          createPromoRelampagoElement(`[ws-prod-sku="${prod.codigo}"] .prod-showcase-image`, date)
        })
      }
   
      const etapaFuncAppPromoRelampago = {
        async HOME() {
          const listHomeProducts = wsMain?.globalData?.listHomeProds?.produtos
          const groupProducts = wsMain?.globalData?.listGroupProds?.grupos?.flatMap(obj => obj.produtos)
          const bruteProducts = []

          if(listHomeProducts) bruteProducts.push(listHomeProducts)
          if(groupProducts) bruteProducts.push(groupProducts)

          appendPromoRelampagoElm(bruteProducts.flat())
        },
        async PRODUTO() {
          const bruteProducts = wsMain?.globalData?.listRelatedProds 

          appendPromoRelampagoElm(bruteProducts)
        },
        async LISTAGEM() {
          const bruteProducts = wsMain?.globalData?.listCategoryProds?.produtos 

          appendPromoRelampagoElm(bruteProducts)
        },
      };
  
      etapaFuncAppPromoRelampago[etapa] != undefined ? etapaFuncAppPromoRelampago[etapa]() : '';
  
    } catch (err) {
      console.error(err);
    }
  }
});

// Variações no card (wsMain.modules['product-list'].variations) — delegado no document porque
// os cards vêm tanto do SSR quanto do client (paginação, carrossel, scroll infinito).
(function () {
  if (window.__wsProdVariationsBound) return;
  window.__wsProdVariationsBound = true;

  let updateArrows = scope => {
    try { wsMain.modules['product-list'].variations.updateArrows(scope); } catch (err) { }
  };

  // Ao entrar no card: baixa as fotos das variações (nascem sem src) e confere as setas (a
  // faixa só tem largura medível com o card visível).
  let enterCard = e => {
    let card = e.target.closest?.('[ws-prod-id]');
    if (!card || (e.type == 'mouseover' && card.contains(e.relatedTarget)) || !card.querySelector('.prod-showcase-variations')) return;
    try { wsMain.modules['product-list'].variations.loadPhotos(card); } catch (err) { }
    updateArrows(card);
  };
  document.addEventListener('mouseover', enterCard);
  document.addEventListener('focusin', enterCard);
  document.addEventListener('touchstart', enterCard, { passive: true });

  // scroll não borbulha — captura.
  document.addEventListener('scroll', e => {
    if (e.target.classList?.contains('prod-showcase-variations-list')) updateArrows(e.target.parentNode.parentNode);
  }, true);

  document.addEventListener('click', e => {
    let arrow = e.target.closest?.('.prod-showcase-variations-arrow');
    if (arrow) {
      e.preventDefault();
      let ul = arrow.parentNode.querySelector('.prod-showcase-variations-list');
      if (ul) ul.scrollBy({ left: (arrow.classList.contains('prev') ? -1 : 1) * Math.max(ul.clientWidth * 0.7, 60), behavior: 'smooth' });
      setTimeout(() => updateArrows(arrow.parentNode.parentNode), 400);
      return;
    }

    // Com botão "Adicionar"/"Comprar" no card, clicar na variação só a SELECIONA (.selected) —
    // quem põe no carrinho é o botão (abaixo). Sem botão, o link leva pra página do produto.
    let buySelector = '.prod-showcase-info-button a[href*="wsFuncBtBuyOnList"]';
    let link = e.target.closest?.('.prod-showcase-variation a[data-ws-var-id]');
    if (link) {
      let card = link.closest('[ws-prod-id]');
      if (!card?.querySelector(buySelector)) return;
      e.preventDefault();
      let item = link.parentNode;
      let wasSelected = item.classList.contains('selected');
      card.querySelectorAll('.prod-showcase-variation.selected').forEach(li => {
        li.classList.remove('selected');
        li.querySelector('a')?.removeAttribute('aria-pressed');
      });
      // Clicar de novo na mesma variação desfaz a seleção.
      if (!wasSelected) {
        item.classList.add('selected');
        link.setAttribute('aria-pressed', 'true');
      }
      card.classList.toggle('has-variation-selected', !wasSelected);
      return;
    }

    // Botão do card com uma variação selecionada: adiciona a variação (o id dela é o product_id
    // do /cart/items/add, igual à página de produto), com o mesmo pós-compra do botão. Sem
    // seleção segue o fluxo de sempre do botão (a API recusa e redireciona pro produto).
    let buyButton = e.target.closest?.(buySelector);
    if (!buyButton || typeof wsFuncBtBuyOnList != 'function') return;
    let card = buyButton.closest('[ws-prod-id]');
    let selected = card?.querySelector('.prod-showcase-variation.selected a[data-ws-var-id]');
    if (!selected) return;

    e.preventDefault();
    let variationId = selected.getAttribute('data-ws-var-id');
    let quantity = parseInt(card.querySelector('.prod-showcase-qty input')?.value) || 1;
    let afterFunction = '';
    if (buyButton.getAttribute('href').includes('openAddedSidebar')) {
      let photo = selected.querySelector('img') || card.querySelector('.prod-showcase-image img');
      window.__wsAddedVariationInfo = {
        name: (card.querySelector('.prod-showcase-info-name')?.textContent.trim() || '') + ' - ' + selected.getAttribute('title'),
        photo: photo?.currentSrc || photo?.getAttribute('src') || photo?.getAttribute('data-ws-var-src') || '',
        qty: quantity
      };
      afterFunction = 'wsMain.modules["cart-drawer"].openAddedSidebar(' + variationId + ', window.__wsAddedVariationInfo)';
    }
    wsFuncBtBuyOnList(document.querySelector('#HD_LV_ID')?.value || '', variationId, afterFunction, quantity);
  });
})();
